// English translation

const en = {
  "crm.title_main":
    "Customer Relationship Management, which centralizes strategies, processes, and software to manage interactions.",
  "party.party.commercial_name": "Commercial Name",
  "crm.activity.planned_date.filter": "Planned date",
  "crm.activity.type_.filter": "Type",
  "crm.prospect.lead_origin": "Lead",
  "crm.prospect.party_category": "Category",
  "crm.prospect.party_category.filter": "Category",
  "crm.prospect.lead_origin.filter": "Lead",
  "crm.prospect.comment": "Comment",
  "crm.activity.opportunity.filter": "Opportunity",
  "crm.opportunity.start_date_from.filter": "Start date from",
  "crm.opportunity.start_date_to.filter": "Start date to",
  "crm.opportunity.end_date.filter": "End date",
  "crm.activity.opportunity": "Opportunity",
  "crm_opportunities_title": "Opportunities",
  "crm_prospects_title": "Prospects",
  "crm_activities_title": "Activities",
  "crm.activity.today": "Today",
  "crm.activity.tomorrow": "Tomorrow",
  "crm.activity.thisWeek": "This Week",
  "crm.activity.nextWeek": "Next Week",
  "crm.activity.overdue": "Overdue",
};

export default en;
